import api from '../../../services/Api';
import { IAuditoriaBaixaPatrimonialResultado } from '../interfaces/IAuditoriaBaixaPatrimonial';

export const AuditoriaBaixaPatrimonialService = {
  async buscarResultado(params: {
    empresaId: number;
    periodo?: string;
  }): Promise<IAuditoriaBaixaPatrimonialResultado> {
    const response = await api.get<IAuditoriaBaixaPatrimonialResultado>('auditoria-baixa-patrimonial/resultado', {
      params: {
        empresaIds: params.empresaId,
        periodo: params.periodo || '',
      },
    });

    return (
      response.data || {
        impactoFiscalTotal: 0,
        impactoFinanceiroTotal: 0,
        totalAvisos: 0,
        totalAlertas: 0,
        totalErros: 0,
        status: 'CONCILIADO',
        mensagemDirecionamento: '',
        fundamentacaoContrapartida: '',
        fundamentacaoRastreabilidade: '',
        baixasSemContrapartida: [],
        baixasSemIdentificacao: [],
        baixasPossiveisAlienacoes: [],
        baixasConciliadas: [],
        baixasReclassificacaoPendenteJustificativa: [],
      }
    );
  },
};
